import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";


function FormImage(props) {
  const { t } = useTranslation();

  const updateListing = (imgIndex, mediaId) => {
    const updatedImages = Array.from(props.image);
    updatedImages.splice(imgIndex, 1);
    props.updateImageList(updatedImages);

    // Call handleRemoveImage with the mediaId
    if (mediaId) {
      props.handleRemoveImage(mediaId);
    }
  };

  return Array.from(props.image).map((img, index) => {
    let imageUrl;

    if (typeof img === "string") {
      imageUrl = img;
    } else if (img instanceof File || img instanceof Blob) {
      imageUrl = URL.createObjectURL(img);
    } else if (img.path) {
      imageUrl = img.path;
    }
    if (!imageUrl) {
      console.error("Invalid image object:", img);
      return null; // Skip rendering if imageUrl is undefined
    }

    const isDefaultImage = typeof img === "string" && img.includes("admin/");

    if (!isDefaultImage) {
      return (
        <div className="flex flex-col items-center px-1" key={index}>
          <img
            className="object-cover h-64 w-full mb-4"
            src={imageUrl}
            alt="uploaded"
            onLoad={() => {
              if (props.localImageOrPdf && img instanceof Blob) {
                URL.revokeObjectURL(imageUrl); // Prevent memory leaks
              }
            }}
          />
          <button
            className="bg-black font-md text-gray-300 shadow-lg p-2 text-white rounded-lg w-full py-2 px-4"
            onClick={() => updateListing(index, img.id)} // Pass mediaId here
          >
            {t("removeFile")}
          </button>
        </div>
      );
    }

    return null;
  });
}

FormImage.propTypes = {
  image: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.object.isRequired,
  ]).isRequired,
  localImageOrPdf: PropTypes.bool,
  updateImageList: PropTypes.func.isRequired,
  handleRemoveImage: PropTypes.func.isRequired,
  deleteMedia: PropTypes.func, // Ensure deleteMedia function is passed as prop
  userId: PropTypes.string,  // Assuming userId is passed as a prop for deleteMedia
};

export default FormImage;
